export const data = {
    name: "ASHLEY GRISON",
    title: "FULL-STACK SOFTWARE ENGINEER",
    contact: {
        title: "Contact",
        city: "Malaga, Spain",
        email: "ashleygrison@gmail.com",
        phone: "+34 619 864 005",
    },
    about: [
        "Ashley is an experienced, full stack software engineer with 18 years experience working across a range of technologies & industries."
    ],
    skills: [
        {
            title: "Technology",
            sets: [
                {
                    title: "Backend",
                    skills: [
                        {
                            name: "Java",
                            percentage: 100
                        },
                        {
                            name: "Golang",
                            percentage: 80
                        },
                        {
                            name: "PHP",
                            percentage: 70
                        },
                    ]
                },
                {
                    title: "Frontend",
                    skills: [
                        {
                            name: "HTML/CSS",
                            percentage: 100
                        },
                        {
                            name: "JavaScript",
                            percentage: 90
                        },
                        {
                            name: "React",
                            percentage: 90
                        },
                    ]
                }
            ]
        },
        {
            title: "Languages",
            sets: [
                {
                    title: "",
                    skills: [
                        {
                            name: "French",
                            percentage: 100
                        },
                        {
                            name: "English",
                            percentage: 100
                        },
                        {
                            name: "Spanish",
                            percentage: 50
                        },
                    ]
                }
            ]
        }
    ],
    blocks: [
        {
            title: "EXPERIENCE",
            items: [
                {
                    t1: "Java Software Developer",
                    t2: "Rindus Technology, Málaga, Spain",
                    t3: "Since March 2021",
                    t4: "Bringing to life the new eCommerce world envisioned by international fashion retailer C&A. " +
                        "Integrating the different SaaS services in the eCommerce architecture. " +
                        "Guaranteeing the process and information flow between multiple services."
                },
                {
                    t1: "Software Development Engineer",
                    t2: "GoDaddy, Greater Boston Area, USA",
                    t3: "Jan 2018 - Feb 2021",
                    t4: "Committed to re-designing the GoDaddy Parking platform using the latest techniques in software development. Day-to-day work involves writing backend processes using the Go programming language, front-end development in React as well as the provisioning and deployment of infrastructure."
                },
                {
                    t1: "Java Software Developer",
                    t2: "Rook Media, Zürich Area, Switzerland",
                    t3: "Mar 2012 - Dec 2017",
                    t4: "Domain Name Monetization. Heavily involved in all aspects of the development lifecycle from systems design, database creation, systems analysis & troubleshooting, backend development right through to UX design and building bespoke UIs."
                },
                {
                    t1: "Java Developer & Project Manager",
                    t2: "Otelo, Paris Area, France",
                    t3: "Jan 2006 - Feb 2012",
                    t4: "Mail-order retail company in France. Contributed to the company’s transformation from pure catalog retailer into a multi-channel business focusing on e-commerce. Developed & maintained the company's e-commerce platform. Day-to-day work involved extending the features of the website's underlying product, Intershop, a proprietary state-of-the-art e-commerce suite written in Java."
                },
                {
                    t1: "PHP Developer & Webmaster",
                    t2: "International Hotel & Restaurant Association, Paris, France",
                    t3: "Jan 2003 - Dec 2005",
                    t4: "International trade association devoted to protecting the interests of the global hospitality industry. Developed and maintained their large content-oriented website. PHP & MySQL web development."
                },
            ]
        },
        {
            title: "TECHNOLOGY",
            items: [
                {
                    t1: "Programming Languages",
                    t2: "Java, Golang, PHP, JavaScript",
                    t4: "I started writing Java web applications in 2006, and since then it has been my favourite backend programming language. JavaScript has become increasingly important in my day-to-day work with the emergence of client-side web applications."
                },
                {
                    t1: "Frameworks & Libraries",
                    t2: "Spring, Hibernate, Intershop, Node, React, jQuery, Goa",
                    t4: "Mainly Java and JavaScript frameworks but also API frameworks for the Go programming language."
                },
                {
                    t1: "Relational Databases",
                    t2: "MySQL, Microsoft SQL Server, IBM Netezza, Oracle",
                    t4: "I have been using relational database management systems throughout my career to manage transaction-oriented applications."
                },
                {
                    t1: "Non-Relational Databases",
                    t2: "Redis, Elasticsearch, Oracle Endeca, Solr",
                    t4: "Experience using key-value stores such as Redis for creating cache systems. I also have experience with Endeca and Solr for creating index and document-based search engines for e-commerce websites."
                },
                {
                    t1: "DevOps, Tools, Platforms & IDEs",
                    t2: "GitHub, Jenkins, Docker, Kubernetes, Maven, AWS, GCP, Eclipse, IntelliJ",
                    t4: "Over the past three years, I have been using Docker to containerize cloud native applications and deploy them to Kubernetes clusters in AWS and GCP."
                },
                {
                    t1: "Programming Paradigms & Design Patterns",
                    t2: "OOP, Functional Programming, MVC, Test-Driven Development",
                    t4: "Familiar with all the best known programming paradigms and design patterns."
                },
            ]
        },
        {
            title: "EDUCATION & TRAINING",
            items: [
                {
                    t1: "Spring Framework",
                    t2: "Zenika, Paris - Nov 2011",
                    t4: "Spring 3.0 5-day training course with author Arnaud Cogoluègnes"
                },
                {
                    t1: "Oracle Endeca E-Commerce Search",
                    t2: "Endeca, Paris - Feb 2008",
                    t4: "Endeca Information Discovery 3-day training course"
                },
                {
                    t1: "Intershop Enfinity",
                    t2: "Jena, Germany - May 2006",
                    t4: "Intershop Enfinity Suite 6.0, 5-day training course"
                },
                {
                    t1: "Master's Degree in American Studies",
                    t2: "Paris Nanterre University, Sep 95 - Jun 99",
                    t4: "Master’s dissertation in European Environmental Law"
                },
            ]
        },
        {
            title: "LANGUAGES",
            items: [
                {
                    t1: "French",
                    t2: "Mother tongue",
                    t4: "I grew up in Paris and spent most of my life there."
                },
                {
                    t1: "English",
                    t2: "Bilingual",
                    t4: "I was born in London to an English mother and a French father."
                },
                {
                    t1: "Spanish",
                    t2: "Fluent",
                    t4: "I have been living in Spain since June 2014."
                },
            ]
        }
    ],
};


// WEBPACK FOOTER //
// ./src/Content.js